<script setup lang="ts">
// import {computed, ref} from "vue";

defineProps<{
  route?: unknown
  user?: unknown
}>()

// const emit = defineEmits<{}>()
</script>

<template>
  <div>
    <pre>{{ {route, user} }}</pre>
  </div>
</template>

<style scoped lang="scss"></style>
